<script>
import Response from "./ResultadoApi.vue";
import playground from "../../../mixins/playground/playground";
import numeroProcesso from "../../../mixins/playground/numeroProcesso";

export default {
  name: "CapaProcesso",
  mixins:[playground, numeroProcesso],
  components: { Response },
  computed: {
    colunas() {
      return [
        { key: "grauFormatado", label: "Instância", isVisible: true },
        {
          key: "dataDistribuicao",
          label: "Data de distribuição",
          isVisible: true,
        },
        { key: "fonteSigla", label: "Tribunal", isVisible: true },
        { key: "fonteSistema", label: "Sistema", isVisible: false },
        { key: "assunto", label: "Assunto", isVisible: true },
        { key: "classe", label: "Classe", isVisible: false },
        { key: "area", label: "Área", isVisible: false },
        {
          key: "orgaoJulgador",
          label: "Órgão julgador",
          isVisible: false,
        },
        {
          key: "valorFormatado",
          label: "Valor da causa",
          isVisible: true,
        },
        { key: "arquivado", label: "Arquivado", isVisible: false },
        {
          key: "dataUltimaMovimentacao",
          label: "Data última movimentação",
          isVisible: false,
        },
        { key: "envolvidos", label: "Outras partes", isVisible: false },
      ];
    },
    informacoes() {
      return [
        {
          label: 'Título',
          value: this.response['titulo_polo_ativo'] || "-" + ' x ' + this.response['titulo_polo_passivo'] || "-"
        },
        {
          label: 'Ano em que foi iníciado',
          value: this.response['ano_inicio'] || "-"
        },
        {
          label: 'Quantidade de movimentações',
          value: this.response['quantidade_movimentacoes'] || "-"
        },
        {
          label: 'Tempo desde a última verificação',
          value: this.response['tempo_desde_ultima_verificacao'] || "-"
        }
      ];
    }
  },
}
</script>

<template>
  <div>
    <form id="form-playground-capa" class="form-playground" @submit.prevent="consultar">
      <div class="space-y-2">
        <label for="numero_cnj" class="font-medium text-sm">Número CNJ</label>
        <input
            id="numero_cnj"
            name="numero_cnj"
            v-model="numero"
            class="input is-large px-2 rounded-md block"
            type="text"
            v-mask="'#######-##.####.#.##.####'"
            placeholder="0000000-00.0000.0.00.0000"
            autofocus="autofocus"
          />
      </div>
    </form>

    <div class="custo">
       <slot name="custo"></slot>
    </div>

    <Btn
      class="btn playground-button consultar-button"
      type="button"
      :loading="$wait.is(`fetching_${this.identificador}`)"
      :disabled="$wait.is(`fetching_${this.identificador}`) || inputInvalido"
      @click="consultar"
    >
      <p class="m-0 font-semibold">Consultar</p>
    </Btn>


    <Response
      v-if="response"
      :responseApi="response"
      :identificador="identificador"
      :key="identificador"
      :logIds="logIds"
      :lista-formatada="itens"
      :colunas="colunas"
      :informacoes-principais="informacoes"
      @carregar-mais-capa-processo="carregarMais"
    >
    </Response>
  </div>
</template>

<style scoped lang="stylus">
.custo
  width 18.5rem

  @media (max-width: 768px)
    width 100%

.form-playground
  display flex
  flex-direction column
  gap 15px

.form-playground .input
  width 18.5rem

  @media (max-width: 768px)
    width 100%

.filtro-button
  padding 10px 20px
  margin-top 1rem

.filtro-button span
  color #2393ae
  background-color ghostwhite
  padding 10px
  border-radius 50%
  margin-left 8px

.playground-button
  background-color #2393ae
  color #fff
  font-size 12px
  border-radius 5px
  font-weight 500

.playground-button:hover
  opacity 0.8

.consultar-button
  padding 20px 40px
</style>
